export const openMail = (email) => {
    window.location = `mailto:${email}`
};